import React, { ReactNode } from 'react';
import classnames from 'classnames';
import styles from './FloButton.module.css';
import { Button } from 'react-bootstrap';
import { FloComponentProps } from 'components';

export enum FloButtonType {
  DEFAULT,
  SMALL,
  SECONDARY,
  DANGER,
}

export interface FloButtonProps extends FloComponentProps {
  text:         string;
  onClick:      (e: any) => void;
  fullWidth?:   boolean;
  showLoader?:  boolean;
  disabled?:    boolean;
  type?:        FloButtonType;
  submit?:      boolean;
  icon?:        ReactNode;
}

export const FloButton: React.FC<FloButtonProps> = React.memo(({
  className,
  text,
  onClick,
  fullWidth = false,
  showLoader = false,
  disabled = false,
  type = FloButtonType.DEFAULT,
  submit,
  icon,
}) => {

  return (
    <Button
      className = {classnames(
        styles.root,
        className,
        { [styles.success]: type === FloButtonType.DEFAULT },
        { [styles.secondary]: type === FloButtonType.SECONDARY || type === FloButtonType.SMALL },
        { [styles.danger]: type === FloButtonType.DANGER }
      )}
      variant   = {type === FloButtonType.SMALL || type === FloButtonType.SECONDARY ? 'info' : 'primary'}
      type      = {submit ? "submit": undefined}
      onClick   = {onClick}
      block     = {fullWidth}
      disabled  = {disabled || showLoader}
      size      = {type === FloButtonType.SMALL ? 'sm' : undefined}
    >
      { showLoader &&
        <span
          className={classnames(
            styles.buttonLoader,
            "spinner-border",
            "spinner-border-sm"
          )}
          role="status"
          aria-hidden="true">
        </span>
      }
      { icon }
      {text}
    </Button>
  );
})

export default FloButton;
